export default {
  getCategoryList: '/gateway/capp/mallcenter/PropSaleForAppRpcService/queryZoneSalesList',
  querySaleList: '/gateway/capp/mallcenter/PropSaleForAppRpcService/querySaleList',
  getActivityData: '/v3/ad/trans/cdsp/request',
  watchAction: '/v3/awardcenter/task/watchAction'
}
